import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useFeatures from '@/pinia/features'
import SanitizedHtml from '@/design-system/atoms/SanitizedHtml.vue'
import { ref } from 'vue'
type Props = {
  caption: string
  features: string[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardFeatureIcon',
  props: {
    caption: {},
    features: {}
  },
  setup(__props: any) {

const { pushFeatures } = useFeatures()
const hover = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    role: "button",
    tabindex: "0",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false)),
    onClick: _cache[2] || (_cache[2] = () => _unref(pushFeatures)(_ctx.features)),
    onKeydown: [
      _cache[3] || (_cache[3] = _withKeys(() => _unref(pushFeatures)(_ctx.features), ["enter"])),
      _cache[4] || (_cache[4] = _withKeys(() => _unref(pushFeatures)(_ctx.features), ["space"]))
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["icon", { hover: hover.value }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("figcaption", null, [
      _createVNode(SanitizedHtml, { rawHtml: _ctx.caption }, null, 8, ["rawHtml"])
    ])
  ], 32))
}
}

})